export enum LookupTypeEnum {
  AbsenceCode,
  ActivityLog,
  AddressedArea,
  AssessmentArea,
  AssessmentDeniedReason,
  AssessmentLevel,
  AssessmentStatus,
  AssessorType,
  CaliforniaAssessmentTest,
  CALPADSMeetingType,
  CasemisIepDelayReasonCode,
  ChildFindStatus,
  ClassroomAndTestingAccommodations,
  CommunicationRecipientType,
  CourseOfStudy,
  Curriculum,
  Disability,
  ELATest,
  ELLanguageProficiency,
  ELLanguageProficiencyTest,
  ELLevel,
  ELProficiencyDescriptor,
  ELPTest,
  ExitReason,
  ExtensionReason,
  ExtensionRequestedBy,
  FurtherAction,
  GoalBank,
  HowWasPlanProvidedToParent,
  HowVerified,
  IEPType,
  Language,
  LanguageProficiency,
  LevelOfUnderstanding,
  MathematicsTest,
  MeetingDelay,
  MeetingType,
  MeetingTypeNew,
  ProgressAttained,
  ReferredBy,
  RTCDocumentType,
  ScienceTest,
  ServiceDuration,
  ServiceIndividualGroup,
  ServiceIndividualGroupIncludeDisabled,
  ServiceFrequency,
  ServiceLocation,
  ServiceLocationIncludeDisabled,
  ServiceProvider,
  ServiceProviderCategory,
  SessionStatus,
  Site,
  SPEDSecurityRole,
  SPEDService,
  SPEDServiceIncludeDisabled,
  SPTDocumentType,
  Status,
  TestingStandardLevel,
  TestingStandardMet,
  SPEDSecurityUser,
  SPEDSecurityRoleModifier
}
